import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "h-40 bg-gray-100"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "p-4" };
const _hoisted_4 = { class: "font-semibold text-gray-900" };
const _hoisted_5 = {
    key: 0,
    class: "text-sm text-gray-600 mt-1 line-clamp-2"
};
const _hoisted_6 = { class: "flex items-center justify-between mt-3" };
const _hoisted_7 = { class: "text-lg font-bold text-gray-900" };
const _hoisted_8 = {
    key: 0,
    class: "text-xs font-medium bg-green-100 text-green-800 px-2 py-1 rounded-full"
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuCard',
    props: {
        menu: {}
    },
    emits: ["select"],
    setup(__props) {
        const props = __props;
        const savingsCent = computed(() => props.menu.referenceSavingsCent || 0);
        const formatPrice = (cent) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "menu-card bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden cursor-pointer hover:shadow-md transition-shadow",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('select', _ctx.menu)))
            }, [
                (_ctx.menu.imageUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("img", {
                            src: _ctx.menu.imageUrl,
                            alt: _ctx.menu.name,
                            class: "w-full h-full object-cover"
                        }, null, 8 /* PROPS */, _hoisted_2)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.menu.name), 1 /* TEXT */),
                    (_ctx.menu.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.menu.description), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(formatPrice(_ctx.menu.menuPriceCent)), 1 /* TEXT */),
                        (savingsCent.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Spare " + _toDisplayString(formatPrice(savingsCent.value)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
